import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-group',
  templateUrl: './select-group.component.html',
  styleUrls: ['./select-group.component.scss']
})
export class SelectGroupComponent implements OnInit, OnDestroy {

  public items: any[] = [];

  public idGroup: any = [];
  public ngxDisabled = true;
  idGroup$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private gasprecioService: GasprecioService,
    private sharedService: SharedService
    ) {
    this.idGroup$ = sharedService.sharedGroup.subscribe((idGroup: string) => {
      if (idGroup !== this.idGroup) {
        this.idGroup = idGroup;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnInit(): void {
    this.getGroups();
  }

  ngOnDestroy() {
    this.idGroup$.unsubscribe();
  }

  getGroups() {
    this.gasprecioService.getGroups().subscribe((data: any) => {
      data.map((group) => {
        this.items.push({ name: group['name'], value: group['_id']});
      });
      this.ngxDisabled = false;
    });
  }

  changeGroup(event: any) {
    // ngx-select may return the value directly or in an array
    let value = event;
    if (Array.isArray(event) && event.length > 0) {
      value = event[0];
    }
    if (value && typeof value === 'object' && value.value !== undefined) {
      value = value.value;
    }
    
    this.idGroup = value;
    this.sharedService.nextGroup = this.idGroup;
    this.sharedService.nextZone = '';
  }

  isSelected(option: any): boolean {
    if (!this.idGroup || 
        (Array.isArray(this.idGroup) && this.idGroup.length === 0) ||
        this.idGroup === '' || 
        this.idGroup === null ||
        this.idGroup === undefined) {
      return false;
    }
    
    let selectedValue: any;
    if (Array.isArray(this.idGroup)) {
      if (this.idGroup.length === 0) {
        return false;
      }
      selectedValue = this.idGroup[0];
      if (selectedValue && typeof selectedValue === 'object' && selectedValue.value !== undefined) {
        selectedValue = selectedValue.value;
      }
    } else {
      selectedValue = this.idGroup;
      if (selectedValue && typeof selectedValue === 'object' && selectedValue.value !== undefined) {
        selectedValue = selectedValue.value;
      }
    }
    
    return option.value === selectedValue || option.value === selectedValue?._id;
  }
}
